export default "__VITE_ASSET__DBGbiaEw__"